import baseFetch from '../baseFetch';

export const getTopSpots = async (
  geonameId: string | string[] | undefined,
  cookies: any,
  includeInternalCams = false,
) =>
  baseFetch(
    `/kbyg/spots/topspots?id=${geonameId}&type=geoname${includeInternalCams ? '&includeInternalCams=true' : ''}`,
    { cookies },
  );
